import { History } from "@mui/icons-material";
import { Alert, Typography } from "@mui/material";
import React from "react";


export const HistoricMaterialInformationAlert: React.FC = () => {
    return <Alert
        severity="info"
        sx={{ m: 1 }}
        icon={<History />}
    >
        <Typography variant="subtitle2" sx={{ marginBottom: "0 !important" }} >
            This material information is historic and may now differ from the inventory material. Please search the inventory to see current details.
        </Typography>
    </Alert>;
};
